<template>
    <v-dialog v-model="dialogSwitch" persistent scrollable width="500">
        <v-form class="mb-3" validate-on="input lazy" @submit.prevent="updateRole">
            <v-card>
                <v-card-title id="heading" class="d-flex justify-space-between">
                    <h4>Update Role</h4>
                    <v-btn density="compact" icon="mdi-close" variant="flat" @click="$emit('update:modelValue',false)"/>
                </v-card-title>

                <v-container>
                    <v-alert v-if="errors.length" class="mb-3 bg-error" closable close-label="Close Alert"
                             density="compact" variant="tonal">
                        <p v-for="error in errors">{{ error }}</p>
                    </v-alert>
                    <v-row>
                        <v-col cols="12">
                            <v-text-field
                                v-model="formData['title']" autofocus
                                :rules="[vRules.required]"
                                density="compact" label="Title"
                            />
                            <v-select
                                v-model="formData['role_type']"
                                :items="role_types"
                                :loading="loading"
                                :rules="[vRules.required]"
                                density="compact"
                                label="Role Type"
                            />
                            <v-select
                                v-if="formData['role_type'] !== 'api'"
                                v-model="formData['portal_id']"
                                :items="portals"
                                :loading="loading"
                                density="compact"
                                item-title="name"
                                :clearable="formData['role_type']==='admin'"
                                :rules="formData['role_type'] !== 'admin'?[vRules.required]:[]"
                                item-value="id" label="Portal"
                            />
                        </v-col>
                    </v-row>
                </v-container>

                <v-card-actions class="px-4 d-flex justify-end">
                    <v-btn size="small" type="button"
                           @click="$emit('update:modelValue',false)">
                        Close
                    </v-btn>
                    <v-btn color="primary" size="small" type="submit">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</template>

<script setup>
import {ref, reactive, onMounted} from "vue";
import {send} from "@/composables/apiClient";
import {useSnackbarStore} from "@/stores/snackBarStore";

const portals = ref([]);
const loading = ref(true);
const snackbar = useSnackbarStore();
const props = defineProps({
    modelValue: Boolean,
    role: {
        type: Object
    }
});

const formData = reactive({
    valid: false,
    title: props.role.title ?? null,
    portal_id: props.role.portal_id ?? null,
    role_type: props.role.role_type ?? null,
});
const emits = defineEmits(['update:modelValue', 'updateRole']);
const dialogSwitch = ref(props.modelValue);
const errors = ref([]);
const role_types = [
    {value: 'api', title: 'API'},
    {value: 'admin', title: 'Admin'},
    {value: 'company', title: 'Company'},
];

onMounted(() => {
    fetchPortals();
});

const fetchPortals = () => {
    send('get', `admin/portals`)
        .then((response) => {
            portals.value = response.data.data;
        })
        .catch((error) => {
            console.log(error)
            showSnackbar('Portals could not be loaded', 'error')
        }).finally(() => loading.value = false)
}
const updateRole = () => {
    errors.value = [];
    send('put', `admin/roles/${props.role.id}`, formData)
        .then((response) => {
            snackbar.showSnackbar(response.data.message);
            if (response.data.success) {
                emits('updateRole', response.data.data.role);
                emits('update:modelValue', false);
            }
        })
        .catch(function (errorResponse) {
            if (errorResponse.response.data.errors) {
                let validationErrors = errorResponse.response.data.errors;
                Object.keys(validationErrors).forEach((key) => {
                    errors.value.push(validationErrors[key][0]);
                });
            } else if (errorResponse.response.data.message) {
                errors.value.push(errorResponse.response.data.message);
            }
            snackbar.showSnackbar('Something went wrong', 'error');
            document.getElementById('heading').scrollIntoView({behavior: 'smooth'});
        })
}

</script>
